import { Typography } from "@mui/material";
import { format } from "date-fns";

import {
  WeeklyPlanningDayFormValues,
  WeeklySeriesDayFormValues,
} from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.types";
import {
  dateToDayOfWeek,
  formatWeekdayName,
} from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.utils";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";

interface Props {
  id: string;
  dayValues: WeeklyPlanningDayFormValues | WeeklySeriesDayFormValues;
  seriesStartDate?: Date | null;
}

export function DayPanelHeading({ id, dayValues, seriesStartDate }: Props) {
  const { language } = useLanguageContext();

  const text = (() => {
    if ("date" in dayValues) {
      return format(dayValues.date, "EEEE, dd.MM.yyyy", { locale: locales[language] });
    }
    if (seriesStartDate != null && dateToDayOfWeek(seriesStartDate) === dayValues.weekday) {
      return format(seriesStartDate, "EEEE, dd.MM.yyyy", { locale: locales[language] });
    }
    return formatWeekdayName(dayValues.weekday, locales[language]);
  })();

  return (
    <Typography id={id} variant="h6" sx={{ width: "100%", lineHeight: "40px" }}>
      {text}
    </Typography>
  );
}
